<template>
<div class="container-fluid" style="margin-bottom: 50px;">
	<service-toolbar :hide-archive-alert="isQuote ? false : true"></service-toolbar>

	<invoice-ui v-if="!serviceHasBatchInvoice || isQuote"
		:is-for-single-service="true"
		:invoice-slug="theInvoice.slug"
		v-on:invoiceSlugChange="slugChange">
	</invoice-ui>

	<div v-else class="wrapper">
		<p class="text-center">
			This service is added to a batch invoice, so it cannot be edited within this service. <router-link :to="'/invoice/'+theInvoice.slug+'/details'">Click here to go to the batch invoice editor.</router-link>
		</p>

		<pdf-js :url="invoicePreviewSrc" :page="1"></pdf-js>
	</div>
</div>
</template>
<script type="text/javascript">
import ServiceToolbar from "./ServiceToolbar"
import InvoiceUi from "./InvoiceUi"
import ServiceMixins from "@/mixins/ServiceMixins.js"

import PdfJs from "@/components/PdfJs"

export default {
	name: "ServiceInvoice",
	components: {
		ServiceToolbar,
		InvoiceUi,
		PdfJs
	},
	mixins: [ServiceMixins],
	data() {
		return {
			theInvoice: null
		}
	},
	watch: {
		'$store.sessionToken'() {
			this.$forceUpdate()
			this.setTheInvoice()
		},
		'$store.service'() {
			this.setTheInvoice()
		}
	},
	computed: {
		invoicePreviewSrc() {
			return window.apiBase+"ServiceInvoice/pdf?slug="+this.theInvoice.slug+"&token="+this.$store.sessionToken+"&humanReadable=true"
		}
	},
	methods: {
		slugChange(slug) {
			let vm = this
			//setTimeout(() => {
				vm.fetchServiceInvoices()
			//},1000)
		},
		setInvoiceDetails(details) {
			this.invoiceDetails = details
		},
		setTheInvoice() {
			let theInvoice, vm = this
			if (!vm.isQuote && "BatchInvoice" in this.$store.service && this.$store.service.BatchInvoice) {
				theInvoice = this.$store.service.BatchInvoice
			}
			else if ("ServiceInvoice" in this.$store.service) {
				theInvoice = this.$store.service.ServiceInvoice.find(inv => {
					if (vm.isQuote && inv.is_quote == 1)
						return true
					else if (!vm.isQuote && inv.is_quote == 0)
						return true
				})		
			}

			if (theInvoice) 
				vm.theInvoice = theInvoice

			else {
				vm.theInvoice = {
					id: null,
					slug: null
				}
			}
		},
		fetchServiceInvoices() {
			let vm = this

			let params = {
				filters: [
					["service_id",this.$store.service.id]
				]
			}

			this.getJSON("ServiceInvoice/get",params).then(response => {
				if (response.success) {
					vm.$store.service.ServiceInvoice = response.data

					vm.setTheInvoice()
				}
			})
		}
	},
	created() {
		let vm = this
		if (this.$route.params.id != 'new-quote' && this.$route.params.id != 'new') {
			this.setServiceIfNotSet(["ServiceFile","TimeLog","Expense","ServiceInvoice","Expense","Category"])
				.then(response => {
					vm.setTheInvoice()
				})
		}

		this.setTheInvoice()
	}
}
</script>

<style type="text/css" scoped>

	.wrapper {
		max-width: 600px;
		margin: auto;
	}

	.incomplete-alert, .worksheet-change-alert {
		margin-left: -15px;
		margin-right: -15px;
		margin-top: -10px;
		margin-bottom: 10px;
		border-radius: 0;
	}

	@media (max-width: 1200px) {

		.incomplete-alert, .worksheet-change-alert {
			margin-top: -15px
		}
	}

	@media (max-width: 767px) {
		.incomplete-alert, .worksheet-change-alert {
			margin-top: -34px;
		}
	}
</style>